import React, {useState, useEffect} from 'react'
import firebase from '../../firebase/config'
import {Link} from 'react-router-dom';
import moment from 'moment';
import {Editor, EditorState, RichUtils} from 'draft-js';
import 'draft-js/dist/Draft.css';
import Compressor from 'compressorjs';
import ModalGuide from '../../components/ModalGuide';

function Content() {

    const hiddenFileInput = React.useRef(null);

    const inputDescRef = React.useRef(null);
    const inputTitleRef = React.useRef(null);

    const [btnMessage, setBtnMessage] = useState("Subir contenido");
    const [posts, setPosts] = useState([])
    const [compressedFile, setCompressedFile] = useState(null);
    const [update, setUpdate] = useState(false);
    const [error, setError] = useState(false) 
    const [success, setSuccess] = useState(false);

    const [emessage, setEmessage] = useState("")
    const [successMsg, setSuccessMsg] = useState("");
    const [palabra, setPalabra] = useState("")
    const [palabrasClave, setPalabrasClave] = useState([])
    const [localidad, setLocalidad] = useState({})

    const [user, setUser] = useState({})
    
    const [post, setPost] = useState({})

    const [postInfo, setPostInfo] = useState({
      titulo: "",
      descripcion: "",
    })

    const [postUInfo, setPostUInfo] = useState({
      titulo: null,
      descripcion: null,
    })

    const [step1, setStep1] = useState(false);
    const [step2, setStep2] = useState(false);
    const [stepStart, setStepStart] = useState(false);

    
    const [file, setFile] = useState(null);
    const [url, setURL] = useState("");
    const [src, setImg] = useState('');
    
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty())
  
    const handleClick = event => {
      hiddenFileInput.current.click();
    };

    const boldText = (e) => {
        e.preventDefault();
        let nextState = RichUtils.toggleInlineStyle(editorState, 'BOLD');
        setEditorState(nextState);
    }
    
    const italicText = (e) => {
        e.preventDefault();
        let nextState = RichUtils.toggleInlineStyle(editorState, 'ITALIC');
        setEditorState(nextState);
    }

    const underlineText = (e) => {
        e.preventDefault();
        let nextState = RichUtils.toggleInlineStyle(editorState, 'UNDERLINE');
        setEditorState(nextState);
    }
  
    const strikethroughText = (e) => {
        e.preventDefault();
        let nextState = RichUtils.toggleInlineStyle(editorState, 'STRIKETHROUGH');
        setEditorState(nextState);
    }

    function handleChange(e) {
      setImg(URL.createObjectURL(e.target.files[0]));    
      setFile(e.target.files[0]);
    }

    const getLocalidad = async(id) =>{
      let tipos = [];
      await firebase.db.collection("Localidades").where("lc", "==", "Localidad Principal")
      .where("aliadoId", "==", id).get().then(val=>{
        val.docs.forEach(item=>{
          setLocalidad(item.data())
        })
      })
    }

    const getPosts = async(aliadoId) =>{
      let tipos = [];
      await firebase.db.collection('Contenido').where("aliadoId", "==", aliadoId)
      .get().then(val => {
        val.docs.forEach(item=>{
          tipos.push(item.data())
          tipos.sort()
        })
        setPosts(tipos)
      })
    }
  
    const handleCompressedUpload = (e) => {
      const image = e.target.files[0];
      new Compressor(image, {
        quality: 0.8, // 0.6 Se puede usar también, pero no es recomendado ir más abajo.
        success: (compressedResult) => { 
          setCompressedFile(compressedResult)
        },
      });
    };

    function checkInputs(object){
      let val = 0
      let array = []
      object["file"] = file
      Object.keys(object).forEach(function(key) {
        if (object[key] === '' || object[key] === null) {
          val++
          array.push(key)
        }
      });
      if(val > 0){
        setError(true)
        setEmessage("Todos los campos son requeridos")
        setTimeout(() => {
          setError(false)
        }, 4000);
        setBtnMessage("Crear contenido")
      }else{
        uploadPost()
        // alert("Todos los inputs estan llenos")
      }
      return val > 0 ? true : false
    }

    const SuccessComponent = ({msg}) => {
      return (
          <div className="success-alert">
              <span className="material-icons mr-2">done</span>
              {msg}
              <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }

    const ErrorComponent = ({msg}) => {
      return (
          <div className="error-alert">
              <span className="material-icons mr-2">error</span>
              {msg}
              <div onClick={()=>{setError(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }
    
    let help = [
      `Aquí podrás compartir contenido de valor para generar interacciones con los Dueños de Mascotas y dar a conocer tu marca. Podrás ver sus “likes” y comentarios.`,
      "*Cada uno de los artículos de Contenido que ingreses en la plataforma, serán verificados por el equipo administrativo de Priority Pet antes de ser subidos a la app de Dueños de Mascotas",
    ]

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          getPosts(val.aliadoId)
          getLocalidad(val.aliadoId)
        });
      }, [])

    return (
      <div className="main-content-container container-fluid px-4">
            {success && <SuccessComponent msg={successMsg === "" ? "Producto cargado exitosamente" : successMsg}/>}
            {error && <ErrorComponent msg={emessage === "" ? "Todos los campos son requeridos" : emessage}/>}
            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
              <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                <div className="row align-items-center">
                  <div className="ml-2 col row">
                    <p className="page-title bold"><Link className="page-title light" to="/configuration">Configuración</Link> <span>Contenido</span></p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-1 mb-0">
                <div className="row align-items-center justify-content-space-around level-2">
                  <i onClick={()=>{setStepStart(true)}} className="material-icons color-white display-5 cursor-pointer">help_outline</i>
                </div>
              </div>
            </div>

            <div className="row position-relative">
              { stepStart && <ModalGuide content={help[0]} direction="bottom" start={true} stateNext={setStep1} statePrev={setStepStart}/> }
              { step1 && <ModalGuide content={help[1]} direction="bottom" start={true} last={true} stateNext={setStep1} statePrev={setStep1}/> }
                <div className="col-lg-7 col-md-7 col-sm-12">
                    <div className="row">
                            {
                                posts.length > 0 ? posts.map(post=>{
                                  return(
                                    <div className="col-md-6 col-sm-12"  key={post.postId}>
                                      <div  onClick={() => setPost(post)}  className="card card-small card-post mb-4">
                                        <div className="card-post__image" style={{backgroundImage: `url(${post.urlImagen})` }}></div>
                                        <div className="card-body">
                                          <h5 className="card-title">
                                            <p className="text-fiord-blue mb-2">{post.titulo}</p>
                                          </h5>
                                          <p className="card-text mb-2">{post.descripcion}</p>
                                        </div>
                                      </div>
                                    </div>
                                )
                            }) : <div className="text-center"><p>No hay contenido</p></div>
                        }

                    </div>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12">
                    { post.titulo != null  && !update ? <div className="card">
                      <div className="card-header-img-width">
                        <img src={post.urlImagen} alt=""/>
                      </div>
                      <div onClick={()=>setPost({})} className="card-close-btn">
                        <span>X</span>
                      </div>
                      <div className="px-4">
                        <div className="card-claim-box">
                          <p className="card-claim-text">{post.titulo}</p>
                        </div>
                        <div className="card-claim-box">
                          <p className="card-claim-title">Descripción</p>
                          <p style={{fontSize: "14px", fontWeight: "300", color: "var(--dark)"}} className="card-claim-text">{post.descripcion}</p>
                        </div>

                      </div>
                      <div className="card-footer">
                        <div className="row">
                          <div className="col-md-6 col-sm-12">
                            <button onClick={deletePost} className="btn btn-danger">Eliminar contenido</button>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <button onClick={()=>{setUpdate(true)}} className="btn btn-primary">Editar contenido</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    : update ?
                    <form onSubmit={e => e.preventDefault() && false }>
                      <div className="card">
                        <div className="card-header text-center">
                          <h4>Actualizar contenido</h4>
                        </div>
                        <div onClick={()=>{setPost({}); setUpdate(false)}} className="card-close-btn">
                          <span>X</span>
                        </div>
                        <div className="px-4">

                          <input type="file"
                            ref={hiddenFileInput}
                            onChange={handleChange} 
                            style={{display: 'none'}}
                          />
                          <div onClick={handleClick} className="card-update-product-img-fwidth">
                            {src !== "" ? <img src={src} alt="" /> : <img src={post.urlImagen} alt="" />}
                          </div>
                          <div className="form-group">
                            <input type="text" onChange={(e)=>{setPostUInfo({...postUInfo, titulo: e.target.value})}} placeholder={post.titulo} className="form-control"/>
                          </div>
                          <div className="form-group">
                            <input type="text" onChange={(e)=>{setPostUInfo({...postUInfo, descripcion: e.target.value})}} placeholder={post.descripcion} className="form-control"/>
                          </div>
                          
                        </div>
                        <div className="card-footer">
                          <button onClick={()=>{updatePost()}} className="btn btn-primary btn-block">{btnMessage}</button>
                        </div>
                      </div>
                    </form>
                    :
                    <form onSubmit={e => e.preventDefault() && false }>
                      <div className="card">
                        <div className="card-header text-center">
                          <h4>Subir contenido</h4>
                        </div>
                        <div className="px-4">
                          <input type="file"
                            ref={hiddenFileInput}
                            onChange={handleChange} 
                            style={{display: 'none'}}
                          />
                          <div onClick={handleClick} className="card-update-product-img-fwidth">
                            {src !== "" ? <img src={src} alt="" /> : <div className="card-header-img-upload"><p className="material-icons icon">add</p><p>Cargar imagen</p></div>}
                          </div>
                          <p className="mt-3 mb-3 text-muted text-center light">Dimensiones recomendadas (600 x 300)</p>
                          <div className="form-row mb-3 align-items-center justify-content-spacebetween">
                            <input ref={inputTitleRef} type="text" onChange={(e)=>{setPostInfo({...postInfo, titulo: e.target.value})}} placeholder="Titulo del contenido" className="form-control col-lg-10 col-lg-12"/>
                          </div>
                          {/* <div className="row no-gutters">
                            <button onMouseDown={boldText}>B</button>
                            <button onMouseDown={italicText}>I</button>
                            <button onMouseDown={underlineText}>Underline</button>
                            <button onMouseDown={strikethroughText}>Strikethrough</button>

                          </div>
                          <Editor editorState={editorState} onChange={setEditorState} /> */}
                          <div className="form-row mb-3 align-items-center justify-content-spacebetween">
                            <textarea ref={inputDescRef} type="text" onChange={(e)=>{setPostInfo({...postInfo, descripcion: e.target.value})}} placeholder="Descripción del contenido" className="form-control col-lg-10 col-lg-12"/>
                          </div>
                          
                        </div>
                        <div className="card-footer">
                          <button onClick={()=>{ checkInputs(postInfo) }} className="btn btn-primary btn-block">{btnMessage}</button>
                        </div>
                      </div>
                    </form>
                    }
                </div>
            </div>

          </div>
    )

    async function uploadPost() {
      setBtnMessage("Subiendo...")
      let id = firebase.db.collection("Contenido").doc().id;
      try {
        await firebase.storage.ref(`/Contenido imagenes/${file.name}`).put(file)
        firebase.storage.ref("Contenido imagenes").child(file.name).getDownloadURL().then((url) => {
          firebase.db.collection("Contenido").doc(id).set({
            aliadoId: user.aliadoId,
            isApproved: false,
            postId: id,
            urlImagen: url,
            pais: localidad.pais,
            titulo: postInfo.titulo,
            descripcion: postInfo.descripcion,
            likes: 0,
            createdOn: moment().toDate(),
          })
        })
        getPosts(user.aliadoId)
        setSuccess(true)
        setFile(null)
        setURL("");
        setImg('');
        inputTitleRef.current.value = ""
        inputDescRef.current.value = ""
        setSuccessMsg("Contenido cargado exitosamente")
        setTimeout(() => {
          setSuccess(false)
          window.location.href = "/configuration/content"
        }, 4000);
        setBtnMessage("Crear contenido")
        window.scrollTo(0, 0)
      } catch(error) {
        alert(error.message)
      }
    }
      
    async function updatePost(){
      if(file){
        await firebase.storage.ref(`/Contenido imagenes/${file.name}`).put(file)
        firebase.storage.ref("Contenido imagenes").child(file.name).getDownloadURL().then((url) => {
          firebase.db.collection("Contenido").doc(post.postId).update({
            urlImagen: url,
            titulo: postUInfo.titulo ?? post.titulo,
            descripcion: postUInfo.descripcion ?? post.descripcion,
          })
        })
        getPosts(user.aliadoId)
      }else{
        try {
          await firebase.db.collection("Contenido").doc(post.postId).update({
            titulo: postUInfo.titulo ?? post.titulo,
            descripcion: postUInfo.descripcion ?? post.descripcion,
          })
          getPosts(user.aliadoId)
        } catch (e) {
          alert(e.message)
        }

      }
    }
  
    async function deletePost(){
      try{
        await firebase.db.collection('Contenido').doc(post.postId).delete()
        // window.location.href = "/configuration/content"
        getPosts(user.aliadoId)
        setPost({})
      }catch(e){
        console.log("Error: " + e);
      }
    }

}

export default Content
